import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PlatformIcon } from "./Brand";
import { PLATFORMS } from "@/data/content";
import { fadeUp, stagger } from "@/lib/motion";

export default function PlatformsStrip() {
  return (
    <section
      id="platforms"
      data-testid="platforms-strip"
      className="relative scroll-mt-24 overflow-hidden border-y border-white/10 bg-panel py-20 lg:py-28"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.15 }}
        >
          <motion.h2
            variants={fadeUp}
            className="max-w-2xl font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl"
          >
            Listen wherever you{" "}
            <span className="font-garamond italic text-cherry">get your podcasts.</span>
          </motion.h2>

          <motion.div variants={stagger} className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-3">
            {PLATFORMS.map((p) => (
              <motion.a
                key={p.id}
                variants={fadeUp}
                data-testid={`platform-${p.id}`}
                href={p.href}
                target="_blank"
                rel="noreferrer"
                className="group flex items-center justify-between rounded-3xl border border-white/10 bg-ink p-7 transition-all duration-300 hover:-translate-y-1 hover:border-cherry/60 hover:shadow-[0_20px_60px_rgba(255,0,85,0.18)]"
              >
                <span className="flex items-center gap-4">
                  <span className="flex h-12 w-12 items-center justify-center rounded-2xl border border-white/10 text-white transition-colors duration-300 group-hover:border-cherry group-hover:text-cherry">
                    <PlatformIcon id={p.id} className="h-6 w-6" />
                  </span>
                  <span className="font-display text-lg font-bold">{p.name}</span>
                </span>
                <ArrowUpRight className="h-5 w-5 text-white/30 transition-all duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-cherry" />
              </motion.a>
            ))}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
